import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import ShoppingCartApp from './components/ShoppingCartApp/ShoppingCartApp';

ReactDOM.render(
    <ShoppingCartApp 
        sessionCartData={sessionCartData} 
        domainId={domainId}
        totalCartItems={total_cart_items}
    />,
    document.getElementById('checkout-container')
);